const check = context => ({
  inAllFranchisees() {
    const { city } = context.$store.getters;
    return city?.id !== 'all';
  },
});

export default check;
